import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { lazy, useContext, useEffect, useState } from 'react';
import { useIntl, defineMessages } from 'react-intl-next';
import { useButton, AkButton, ButtonSet } from '../button';
import { transformFormData } from './transformFormData';
import { emotionInstance } from '../../../context/emotion';
export var AkForm = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_form" */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.default
    };
  });
});
export var AkFormFooter = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_form" */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.FormFooter
    };
  });
});
export var AkFormField = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_form" */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
export var isActionButton = function isActionButton(auxElement) {
  return auxElement.key && auxElement.key.startsWith('actionButton');
};
export function useForm(_ref) {
  var forgeDoc = _ref.forgeDoc,
    dispatch = _ref.dispatch,
    render = _ref.render;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _forgeDoc$props = forgeDoc.props,
    _forgeDoc$props2 = _forgeDoc$props === void 0 ? {} : _forgeDoc$props,
    _forgeDoc$props2$subm = _forgeDoc$props2.submitButtonText,
    submitButtonText = _forgeDoc$props2$subm === void 0 ? formatMessage(messages.forgeFormSubmitButtonText) : _forgeDoc$props2$subm,
    onSubmit = _forgeDoc$props2.onSubmit,
    _forgeDoc$props2$subm2 = _forgeDoc$props2.submitButtonAppearance,
    submitButtonAppearance = _forgeDoc$props2$subm2 === void 0 ? 'default' : _forgeDoc$props2$subm2;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];

  /**
   * Toggle the Form's React key to remount the component for clearing fields
   * Using the formProps' reset() would trigger our custom form validation for isRequired on some fields
   */
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    formKey = _useState4[0],
    setFormKey = _useState4[1];
  var onSubmitHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formData) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return dispatch({
              type: 'event',
              extensionData: {},
              handler: onSubmit,
              args: [transformFormData(formData)]
            });
          case 4:
            setFormKey(Number(!formKey));
          case 5:
            _context.prev = 5;
            setLoading(false);
            return _context.finish(5);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1,, 5, 8]]);
    }));
    return function onSubmitHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var akSubmitButtonProps = _objectSpread(_objectSpread({}, useButton({
    forgeDoc: {
      type: 'Button',
      props: {
        text: submitButtonText,
        appearance: submitButtonAppearance
      },
      children: []
    },
    dispatch: dispatch,
    render: render
  }).akButtonProps), {}, {
    onClick: undefined,
    type: 'submit',
    isLoading: loading
  });
  var children = forgeDoc.children.filter(function (x) {
    return !isActionButton(x);
  });
  var actions = forgeDoc.children.filter(isActionButton).map(function (actionButton) {
    return _objectSpread(_objectSpread({}, actionButton), {}, {
      props: _objectSpread(_objectSpread({}, actionButton.props), {}, {
        appearance: 'subtle'
      })
    });
  });
  return {
    akFormProps: {
      key: formKey,
      onSubmit: onSubmitHandler,
      children: function children() {
        throw Error('@atlassian/forge-ui: Invalid composition of UI Kit useForm and Atlaskit Form');
      }
    },
    akSubmitButtonProps: akSubmitButtonProps,
    htmlFormProps: {
      // @ts-ignore
      'data-testid': 'form',
      className: emotionInstance.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        width: 100%;\n        margin-top: 0;\n        > *:not(footer) {\n          margin-top: 0;\n        }\n        > *:not(:last-child) {\n          margin-bottom: ", ";\n        }\n        ", "\n      "])), "var(--ds-space-100, 8px)", children.length === 0 ? "\n            > footer {\n              margin-top: 0;\n            }\n            " : '')
    },
    akFormFooterProps: {
      align: 'start'
    },
    children: children.map(render),
    actions: actions.length > 0 ? actions.map(render) : null
  };
}
export var FormContext = /*#__PURE__*/React.createContext(null);
export var FormStateChangeNotifier = function FormStateChangeNotifier(_ref3) {
  var name = _ref3.name,
    value = _ref3.value;
  var formContext = useContext(FormContext);
  useEffect(function () {
    formContext === null || formContext === void 0 || formContext.setFormValue(name, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, Array.isArray(value) ? value.join() : value]);
  return null;
};
export function Form(props) {
  var _useForm = useForm(props),
    actions = _useForm.actions,
    akFormFooterProps = _useForm.akFormFooterProps,
    akFormProps = _useForm.akFormProps,
    akSubmitButtonProps = _useForm.akSubmitButtonProps,
    children = _useForm.children,
    htmlFormProps = _useForm.htmlFormProps;
  var shouldFitContainer = akSubmitButtonProps.shouldFitContainer,
    iconBefore = akSubmitButtonProps.iconBefore,
    iconAfter = akSubmitButtonProps.iconAfter,
    loading = akSubmitButtonProps.isLoading,
    disabled = akSubmitButtonProps.isDisabled,
    appearance = akSubmitButtonProps.appearance,
    onClick = akSubmitButtonProps.onClick,
    type = akSubmitButtonProps.type,
    buttonChildren = akSubmitButtonProps.children;
  var align = akFormFooterProps.align;
  var key = akFormProps.key,
    onSubmit = akFormProps.onSubmit;

  // @ts-ignore Ignoring the fact that "data-testid" is not part of the declared type
  var className = htmlFormProps.className,
    dataTestId = htmlFormProps['data-testid'];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    formValues = _useState6[0],
    setFormValues = _useState6[1];
  var setFormValue = function setFormValue(name, value) {
    setFormValues(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, value));
    });
  };
  return /*#__PURE__*/React.createElement(AkForm, {
    key: key,
    onSubmit: onSubmit
  }, function (_ref4) {
    var formProps = _ref4.formProps;
    var onSubmit = formProps.onSubmit,
      onKeyDown = formProps.onKeyDown,
      ref = formProps.ref;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      React.createElement("form", {
        onSubmit: onSubmit,
        onKeyDown: onKeyDown,
        ref: ref
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: className,
        "data-testid": dataTestId
      }, /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: {
          formValues: formValues,
          setFormValue: setFormValue
        }
      }, children), /*#__PURE__*/React.createElement(AkFormFooter, {
        align: align
      }, /*#__PURE__*/React.createElement(ButtonSet, null, /*#__PURE__*/React.createElement(AkButton, {
        shouldFitContainer: shouldFitContainer,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isLoading: loading,
        isDisabled: disabled,
        appearance: appearance,
        onClick: onClick,
        type: type
      }, buttonChildren), actions)))
    );
  });
}
export var messages = defineMessages({
  forgeFormSubmitButtonText: {
    id: 'forge-ui.form.submit-button.text',
    defaultMessage: 'Submit',
    description: 'Text for a button for a user to submit their form input.'
  }
});